import React from "react"
import styles from "./styles.scss"
import cx from "classnames"
import SearchBarWrapper from "components/SearchBarWrapper"
import { Link } from "react-router-dom"
import {
  landingPagePath,
  infoPagePath,
  contactPagePath,
} from "utils/paths"

export const TYPES = {
  PRIMARY: "primary",
  DARK_GRAY: "darkgray",
}

export const SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
}

export const SEARCH_BAR = {
  HIDE_SEARCH_BAR: "hideSearchBar",
  SHOW_SEARCH_BAR: "showSearchBar",
}

class Header extends React.Component {
  static defaultProps = {
    hasSearchBar: true,
  }
  render() {
    const { headerType, headerSize, hasSearchBar, searchBar } = this.props
    return (
      <div
        className={cx(styles.header, styles[headerType || TYPES.PRIMARY])}
      >
        <div
          className={cx(
            styles.contentWrapper,
            styles[headerSize || SIZES.LARGE]
          )}
        >
          <Link to={landingPagePath()}>
            <div className={styles.logo}>
              <img
                src={require("images/logo.png")}
                className={styles.logo}
              />
            </div>
          </Link>
          {hasSearchBar && (
            <div
              className={cx(
                styles.searchBarDefault,
                styles[searchBar || SEARCH_BAR.HIDE_SEARCH_BAR]
              )}
            >
              <SearchBarWrapper />
            </div>
          )}

          <div className={styles.links}>
            <Link to={infoPagePath()} className={styles.link}>
              <p>Hur du lägger till ett företag</p>
            </Link>
            <Link to={contactPagePath()} className={styles.link}>
              <p>Kontakta oss</p>
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// src/components/Header/index.jsx